module.exports = __webpack_public_path__ + "img/zanwushuju.9f42a722.png";